import { ReactNode } from 'react';

import { InfoBannerType } from '../InfoBanner/InfoBanner';

export enum MoveStatusType {
  SEARCH = 'Search',
  WAITING_TO_ACCEPT = 'WaitToAccept',
  WAITING_FOR_YOUR_MOVE = 'WaitingForYourMove',
  WAITING_FOR_OPPONENT = 'WaitingForOpponent',
  WAITING_FOR_YOUR_REVEAL = 'WaitingForYourReveal',
  WAITING_FOR_OPPONENT_REVEAL = 'WaitingForOpponentReveal',
}

export interface MoveStatusRendererProps {
  /**
   * statusIcon is an optional prop that determines which icon to display
   */
  statusIcon?: MoveStatusType;
  /**
   * title is the text to display in the InfoBanner
   */
  title?: string | ReactNode;
  /**
   * className is an optional prop for additional styling
   */
  className?: string;
  /**
   * type is the type of InfoBanner, default is INFO
   */
  type?: InfoBannerType;
  /**
   * infoBannerClassName is an optional prop for additional styling of the InfoBanner
   */
  infoBannerClassName?: string;
  /**
   * hideIconOnMobile is an optional prop to hide the icon on mobile devices
   */
  hideIconOnMobile?: boolean;
}
